const lgMin = 992;
const mdMax = 991;

export default { lgMin, mdMax };
